"use client";

import { ArrowUp01Icon, ArrowUp02Icon } from "@hugeicons/core-free-icons";
import { Button } from "../ui/button";
import { HugeiconsIcon } from "@hugeicons/react";
import { Typography } from "../ui/typography";

export const BackToTopBtn = () => {
  const handleScrollToTop = () => {
    if (window && typeof window !== "undefined") {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  };

  return (
    <Button
      variant="ghost"
      className="rounded-full p-0"
      onClick={handleScrollToTop}
    >
      <Typography variant="bodyESRegular" className="hidden md:block">
        بازگشت به بالا
      </Typography>
      <div className="rounded-[12px] border border-black-100 p-1.5">
        <HugeiconsIcon
          icon={ArrowUp02Icon}
          size={24}
          strokeWidth={1.5}
          className="size-6"
        />
      </div>
    </Button>
  );
};
